/* RESPONSIBLE TEAM: team-standalone */

import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';

class ChannelTest extends Route {
  @service declare appService: AppService;

  reactEnabled() {
    return this.appService.app.canStandalonePlatformAccessReactIntegrationPages;
  }
}

export default ReactRoute(ChannelTest);
